import {
    Box,
    Button,
    Dialog,
    IconButton,
    Typography,
    DialogTitle,
    DialogActions,
    DialogContent,
} from "@mui/material";
import ThemeColors from "config/colors";
import {useTranslation} from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import CustomButton from "./CustomButton";

const ConfirmationDialog = ({
                                title,
                                onClose,
                                isLoading,
                                description,
                                open = false,
                                severity = "primary",
                                hasClose = true,
                                hasCancel = true,
                                hasConfirm = true,
                                fullWidth = true,
                                maxWidth = 'sm',
                                children,
                                btnCancelName = "Cancel",
                                btnConfirmName = "Confirm",
                                hasExtraButton = false,
                                extraButtonName = "",
                            }) => {
    const {t} = useTranslation();

    const handleClose = (isRefresh, reason) => {
        onClose(isRefresh, reason);
    };

    const colors = {
        primary: ThemeColors.brandingRed,
        success: ThemeColors.brandingGreen,
        error: ThemeColors.redColor,
    };

    return (
        <Dialog
            onClose={(event, reason) => handleClose(isLoading, reason)}
            open={open}
            fullWidth={fullWidth}
            maxWidth={maxWidth}
            disableEscapeKeyDown
        >
            <Box
                className="d-flex align-items-center justify-content-between"
                style={{backgroundColor: ThemeColors.whiteColor, color: ThemeColors.brandingRed}}
            >
                <DialogTitle>
                    <Typography variant="h6" className="font-weight-bold">
                        {t(title)}
                    </Typography>
                </DialogTitle>

                {hasClose && <IconButton onClick={() => handleClose(isLoading)} size="large">
                    <CloseIcon sx={{color: ThemeColors.brandingRed}}/>
                </IconButton>}
            </Box>
            <DialogContent dividers className="py-4">
                {description && <Typography gutterBottom>{description}</Typography>}
                {children ?? null}
            </DialogContent>
            <DialogActions>
                {hasCancel && (
                    <Button
                        color="primary"
                        disabled={isLoading}
                        onClick={() => handleClose(isLoading)}
                    >
                        {t(`${btnCancelName}`)}
                    </Button>
                )}
                {hasExtraButton && (
                    <Button
                        onClick={() => {
                            handleClose("extraButton");
                        }}
                        disabled={isLoading}
                        color="primary"
                    >
                        {t(`${extraButtonName}`)}
                    </Button>
                )}
                {hasConfirm && (
                    <Button
                        onClick={() => handleClose(true)}
                        disabled={isLoading}
                        sx={{
                            color: ThemeColors.whiteColor,
                            backgroundColor: ThemeColors.brandingRed,
                            borderRadius: 2,
                            padding: '8px 16px',
                            '&:hover': {
                                color: ThemeColors.whiteColor,
                                backgroundColor: ThemeColors.brandingRed,
                            }
                        }}
                    >
                        {t(`${btnConfirmName}`)}
                    </Button>
                    //         <CustomButton
                    //         title={t(`${btnConfirmName}`)}
                    //     onClick={() => handleClose(true)}
                    //     style={{
                    //         padding: '16px 24px'
                    //     }}
                    //     height={'40px'}
                    //     backgroundColor={ThemeColors.brandingRed}
                    //     borderRadius={4}
                    //     size="small"
                    // />
                )}
            </DialogActions>
        </Dialog>
    )
        ;
};

export default ConfirmationDialog;
